import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import HomeIcon from "@mui/icons-material/Home";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import DescriptionIcon from "@mui/icons-material/Description";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";

import CustomForm from "../../../helper-components/form/CustomForm";
import NavigationFooter from "../../../helper-components/misc/NavigationFooter";

import LibrariesTable from "./components/LibrariesTable";

import { getLanguage } from "../../../config/language/language.js";

/**
 * The libraries page.
 */
export default function Libraries(props) {
    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomForm title={getLanguage().LIBRARIES_TITLE} subtitle={getLanguage().LIBRARIES_SUBTITLE} icon={<SubscriptionsIcon />} />
                </Grid>

                <Grid item xs={12}>
                    <LibrariesTable {...props} />
                </Grid>

                <NavigationFooter
                    rows={2}
                    options={[
                        {
                            path: `/database/resources`,
                            title: "Resources",
                            variant: "outlined",
                            icon: <DescriptionIcon />
                        },
                        {
                            path: `/database/transcripts`,
                            title: "Transcripts",
                            variant: "outlined",
                            icon: <TextFieldsIcon />,
                            className: "tour-libraries-7"
                        },
                        {
                            path: `/home`,
                            title: "Home",
                            variant: "outlined",
                            icon: <HomeIcon />
                        }
                    ]}
                />
            </Grid>
        </Container>
    );
}
